<script>
import EmptyStateBlock from '@/components/general/empty-state-block.vue'
import VuetifyTextClass from '@/shared/constants/core/VuetifyTextClass'

export default {
  name: 'CandidateListErrorState',
  components: { EmptyStateBlock },
  props: {
    error: {
      type: Object,
      required: true,
    },
  },
  data() {
    return { VuetifyTextClass }
  },
  computed: {
    isNoLocationsAccessibleError() {
      const NoLocationsAccessibleCode = 'candidate_query_no_accessible_scope'

      return (
        this.error?.noScope ||
        (this.error?.statusCode === 403 &&
          this.error?.error?.data?.code === NoLocationsAccessibleCode)
      )
    },
    activeError() {
      return this.isNoLocationsAccessibleError
        ? {
            title: this.$t('candidateList.noScope.title'),
            body: this.$t('candidateList.noScope.body'),
            subtitle: this.$t('candidateList.noScope.subtitle'),
            canRetry: false,
          }
        : {
            title: this.$t('candidateList.error.title'),
            body: this.$t('candidateList.error.body'),
            subtitle: this.$t('candidateList.error.subtitle'),
            cta: this.$t('candidateList.error.cta'),
            canRetry: true,
          }
    },
  },
}
</script>

<template>
  <EmptyStateBlock :key="`candidate-list-${activeError.title}`">
    <template v-slot:icon>
      <v-icon size="60" color="red lighten-1">mdi-alert-circle-outline</v-icon>
    </template>

    <template v-slot:title>
      <h3 :class="['my-2', VuetifyTextClass.h5]">
        {{ activeError.title }}
      </h3>
    </template>

    <template v-slot:description>
      <p :class="VuetifyTextClass.smallBody">
        {{ activeError.body }}
      </p>
      <p :class="VuetifyTextClass.smallBody">
        {{ activeError.subtitle }}
      </p>
    </template>

    <template v-slot:button>
      <v-btn
        v-if="activeError.canRetry"
        data-testid="candidate-list-error-retry"
        color="primary"
        depressed
        outlined
        class="mt-2"
        @click="$emit('retry')"
      >
        {{ activeError.cta }}
      </v-btn>
    </template>
  </EmptyStateBlock>
</template>
